import { z } from "zod";

const localizedText = z.object({
  en: z.string().optional(),
  ar: z.string().optional()
});

// startAt/endAt come from <input type="datetime-local"> as local-time strings
// (or "" for unset); converted to ISO in the dialog before the API call.
export const systemMessageFormSchema = z
  .object({
    title: localizedText,
    body: localizedText,
    type: z.enum(["info", "announcement", "success", "warning", "urgent"]),
    displayType: z.enum(["banner", "popup", "both"]),
    dismissible: z.boolean(),
    enabled: z.boolean(),
    startAt: z.string().optional(),
    endAt: z.string().optional(),
    linkUrl: z.string().url("Invalid URL format").optional().or(z.literal("")),
    linkText: localizedText,
    // Which languages the admin is writing in; only those inputs are shown and sent.
    languages: z.enum(["en", "ar", "both"]),
    audience: z.enum(["all", "specific"]),
    organizationIds: z.array(z.string())
  })
  .refine((data) => data.languages === "ar" || data.body.en?.trim(), {
    message: "Write the English message",
    path: ["body", "en"]
  })
  .refine((data) => data.languages === "en" || data.body.ar?.trim(), {
    message: "Write the Arabic message",
    path: ["body", "ar"]
  })
  .refine((data) => data.audience === "all" || data.organizationIds.length > 0, {
    message: "Pick at least one organization",
    path: ["organizationIds"]
  })
  .refine((data) => !data.startAt || !data.endAt || new Date(data.endAt) > new Date(data.startAt), {
    message: "End time must be after start time",
    path: ["endAt"]
  });

export type SystemMessageFormData = z.infer<typeof systemMessageFormSchema>;
